module.exports = __webpack_public_path__ + "img/bg_2_zh.3aaa96c9.png";